<template>
    <div class="tickets-possibles-container">
        <BaseSelect
            v-model="localListTicketPossibles"
            :label="$t('experience.step7.tickets_possibles.label')"
            :multiple="true"
            :options="options_tickets"
            :state="getState('list_ticket_possibles')"
            @input="onInput"
            :error="errors.list_ticket_possibles"
            :searchable="true"
            option-label="label"
            option-value="value"
            class="transparent-select ppv2-w-full"
            class-added="!ppv2-h-[40px] !ppv2-min-h-[40px] !ppv2-text-xs"
            :customSizeLabel="13"
            :showSelectionControls="true"
            :selectAllText="$t('experience.step7.ticketingOptions.selectBtn')"
            :deselectAllText="$t('experience.step7.ticketingOptions.deselectBtn')"
            @open="$emit('focus')"
            :floatingLabel="true"
            :floatingLabelBg="theme.mode === 'dark' ? '#141243' : '#fff'"
        />
    </div>
</template>

<script>
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import CustomInput from '../../../Inputs/CustomInput.vue'
import BaseSelect from '../../../Shared/BaseSelect.vue'
import DashedCard from '../../../Shared/DashedCard.vue'
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeSizeVertical from '../../../../utils/normalizeSizeVertical'

export default {
    name: 'TicketsPossibles',
    components: {
        BaseSwitch,
        CustomInput,
        BaseSelect,
        DashedCard,
    },
    props: {
        isTicketPossibles: { type: Boolean, default: true },
        minTicket: { type: [Number, String], default: 1 },
        maxTicket: { type: [Number, String], default: -1 },
        listTicketPossibles: { type: Array, default: () => [] },
        errors: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            localIsTicketPossibles: this.isTicketPossibles,
            localListTicketPossibles: Array.isArray(this.listTicketPossibles) ? [...this.listTicketPossibles] : [],
            options_tickets: [],
        }
    },
    watch: {
        isTicketPossibles(val) {
            if (this.localIsTicketPossibles !== val) {
                this.localIsTicketPossibles = val
            }
        },
        minTicket(val) {
            this.generateOptions()
        },
        maxTicket(val) {
            this.generateOptions()
        },
        // ✅ immediate: true so the selection applied after mount (edit mode) is picked up
        listTicketPossibles: {
            handler(val) {
                if (JSON.stringify(this.localListTicketPossibles) !== JSON.stringify(val)) {
                    this.localListTicketPossibles = Array.isArray(val) ? [...val] : []
                }
            },
            immediate: true,
        },
    },
    mounted() {
        this.generateOptions()
    },
    methods: {
        normalizeSize,
        normalizeSizeVertical,
        getState(field) {
            if (this.errors && this.errors[field]) return 'error'
            let val = null
            if (field === 'list_ticket_possibles') val = this.localListTicketPossibles

            if (val !== null && val !== undefined && val !== '') return 'valid'
            return 'default'
        },
        onInput() {
            this.$emit('update:isTicketPossibles', this.localIsTicketPossibles)
            this.$emit('update:listTicketPossibles', this.localListTicketPossibles)
        },

        generateOptions() {
            let options = []
            // ✅ FIX: Ensure minimum is always at least 1 (no "Joueur 0")
            let min = Number(this.minTicket)
            if (isNaN(min) || min === -1 || min === null || min < 1) {
                min = 1
            }

            const max = Number(this.maxTicket)

            if (isNaN(max) || max < min || max === -1) return

            // Prevent huge array generation causing browser freezes
            const safeMax = Math.min(max, 99)

            // ✅ Generate all options (don't exclude selected ones)
            // BaseSelect needs all options to display labels correctly
            for (let i = min; i <= safeMax; i++) {
                options.push({
                    label: `${this.$t('experience.step7.tickets_possibles.player')} ${i}`,
                    value: i,
                })
            }
            this.options_tickets = Object.freeze(options)
        },
    },
}
</script>

<style scoped>
.transparent-select :deep(.vs__dropdown-toggle) {
    background: transparent !important;
}
/* Hide already-selected options from the dropdown list */
.transparent-select :deep(.vs__dropdown-option--selected) {
    display: none;
}
</style>
